import React, { Component } from 'react';

import HeroSection from '../components/HeroSection';

class Resume extends Component {
  render() {
    return (
      <main>
        <HeroSection
            imageSrc="https://res.cloudinary.com/dpoz8quj5/image/upload/v1510394678/milkyway_dn01bz.jpg"
            imagePosX="right"
            h1="Peter Liu" h2="Philadelphia, PA">
        </HeroSection>
        <section className="flex-section">
          <div className="resume-container">
            <h1>Resume</h1>
            <a className="icon-link" href="./assets/data/Resume-PeterLiu.pdf"><img alt="PDF Resume" src="./icon/fa/light/file-pdf.svg" style={{width: '24px'}}></img></a>
            <div className="resume-content">
              <h2>Work Experience</h2>

              <div className="entry">
                <span className="company">
                  <h3>Self</h3>
                </span>

                <span className="location">Remote</span>
                <span className="title">Freelance Web Developer & IT Consultant</span>
                <span className="year">July 2017 - present</span>
                <ul>
                  <li>Design, architect, and develop front-end/full-stack web applications and IT solutions</li>
                  <li>Communicate with clients to determine project requirements and goals, to define the scope, plan timelines, and set deadlines</li>
                  <li>Prepare quarterly BMI Music Use Reports and monthly SoundExchange Reports of Use with additional data from the MusicBrainz API for internet radio stations (2018-2019)</li>
                </ul>
              </div>

              <div className="entry">
                <span className="company">
                  <a href="https://creek.fm/" target="_blank" rel="noopener noreferrer">
                    <h3>Creek</h3>
                  </a>
                </span>

                <span className="location">Remote</span>
                <span className="title">Freelance Web Developer</span>
                <span className="year">July 2017 - June 2019</span>
                <ul>
                  <li>Integrated Vue.js all-in-one radio platform onto radio station websites with plain JavaScript, jQuery, and PHP/Wordpress</li>
                  <li>Created custom Vue components based on client needs</li>
                  <li>Clients included <a href="http://kzfr.org/">KZFR 90.1FM</a>, <a href="http://www.jazzgroove.org/">The Jazz Groove</a>, <a href="http://xraytv.org/">XRAY TV</a>, <a href="http://kwmr.org/">KWMR FM</a>, and <a href="https://www.krfc.fm/">KRFC 88.9FM</a> </li>
                </ul>
              </div>

              <div className="entry">
              <span className="company">
                <a href="https://www.thinkcompany.com/" target="_blank" rel="noopener noreferrer">
                  <h3>Think Company</h3>
                </a>
              </span>

              <span className="location">Philadelphia, PA</span>
              <span className="title">Web Developer (Contract)</span>
              <span className="year">November 2016</span>
              <ul>
                <li>Assisted development of a client site redesign utilizing WordPress and the Advanced Custom Fields plugin</li>
                <li>Stylized and added JavaScript and PHP functionality to page templates</li>
              </ul>
              </div>

              <div className="entry">
              <span className="company">
                <a href="http://wkdu.org" target="_blank" rel="noopener noreferrer">
                  <h3>WKDU Philadelphia 91.7FM</h3>
                </a>
              </span>

              <span className="location">Philadelphia, PA</span>
              <span className="title">Systems Administrator & Technical Consultant</span>
              <span className="year">July 2017 - present</span>

              <ul>
                <li>Provide strategic guidance on general technology, broadcast engineering infrastructure, and equipment procurement</li>
                <li>Develop updates for the <a href="https://emm.wkdu.org">WKDU Electronic Music Marathon</a> website and create other applications to improve workflow</li>
                <li>Architect solutions for broadcast automation, online streaming, program audio archiving, and remote FM broadcasting (Shell scripts, Nginx, Icecast)</li>
                <li>Support legacy OS X and macOS systems (10.7.5 Lion to 10.13 High Sierra) and install hardware/peripheral components for MacOS & Ubuntu systems</li>
                <li>Administer G Suite, mailing lists, and file-sharing servers</li>
                <li>Organize and manage status of projects, tasks and support requests using Trello</li>
                <li>Mentor students with interests in software, hardware, and web/mobile development</li>
              </ul>

              <span className="title">Systems Administrator & Webmaster</span>
              <span className="year">June 2014 - July 2017</span>
              
              <ul>
                <li>Develop new sites for the <a href="https://emm.wkdu.org">WKDU Electronic Music Marathon</a> and display <a href="http://wkdu.herokuapp.com/">Now Playing</a> track information</li>
                <li>Maintain content on <a href="http://wkdu.org">primary WKDU website</a> through Drupal using CSS and PHP</li>
                <li>Support legacy OS X systems (10.4 Tiger to 10.6.8 Snow Leopard) and install hardware/peripheral components</li>
                <li>Integrate Google Analytics on all websites to improve listener audience targeting</li>
                <li>Handle merchandise inventory, sales, and product information via TouchNet e-commerce platform</li>
              </ul>

              <span className="title">General Manager</span> 
              <span className="year">June 2014 - July 2015</span>
              
              <ul>
                <li>Managed student organization of 70+ members</li>
                <li>Maintained full responsibility for the actions, commitments, and expenditures of WKDU</li>
                <li>Acted as official liaison between WKDU and Drexel University administration</li>
                <li>Continued compliance of all FCC regulations regarding non-commercial educational broadcast stations</li>
                <li>Drafted and filed itemized budget request for 2015-2016 station management to the Drexel Student Activity Fee Allocation Committee</li>
              </ul>
              </div>
              
              <div className="entry">
              <span className="company">
                <a href="https://www.monetate.com/" target="_blank" rel="noopener noreferrer">
                  <h3>Monetate</h3>
                </a>
              </span>
              
              <span className="location">Conshohocken, PA</span>
              <span className="title">Software Engineer (Co-op)</span>
              <span className="year">April 2014 - September 2014</span>
              
              <ul>
                <li>Assisted feature development for client-facing UI with the Google Closure Library</li>
                <li>Managed Python RPC functions and SQL queries within the Django framework</li>
                <li>Maintained JavaScript and Python codebase for dynamic in-browser graphics editor (<a href="http://www.monetate.com/platform/technology/">ContentBuilder</a>)</li>
                <li>Utilized Amazon EC2 services, Git, and JIRA for day-to-day project management</li>
              </ul>
              </div>
              
              <div className="entry">
              <span className="company">
                <a href="https://www.epam.com/solutions/digital-engagement" target="_blank" rel="noopener noreferrer">
                  <h3>EPAM Empathy Lab</h3>
                </a>
              </span>

              <span className="location">Conshohocken, PA</span>
              <span className="title">HTML/JS Developer (Contract)</span>
              <span className="year">January 2014 - April 2014</span>
              
              <ul>
                <li>Assisted development of various Node.js web applications (HTML5/JS/CSS3) for clients including Vertical Screen, Rodale, and Men's Health</li>
                <li>Built project scaffolding tool with GruntJS</li>
                <li>Optimized responsive websites for touch devices (iPad, iPhone, Android)</li>
              </ul>
              
              <span className="title">Software Engineer (Co-op)</span>
              <span className="year">April 2013 - September 2013</span>
              
              <ul>
                <li>Assisted with development of asynchronous single-page HTML5/JavaScript web application (Backbone.js)</li>
                <li>Created unit tests with QUnit and PhantomJS</li>
                <li>Wrote automation scripts using Node.js and GruntJS</li>
                <li>Supported team with kernel and firmware updates on embedded Linux set-top box devices</li>
                <li>Worked with clients such as VerticalScreen, Liberty Global, and Sentara Healthcare</li>
              </ul>
              </div>

              <div className="entry">
              <span className="company">
                <a href="https://www.pjm.com/" target="_blank" rel="noopener noreferrer">
                  <h3>PJM Interconnection</h3>
                </a>
              </span>

              <span className="location">Norristown, PA</span>
              <span className="title">Corporate Applications Developer (Co-op)</span>
              <span className="year">April 2012 - September 2012</span>
              
              <ul>
                <li>Enhanced and maintained content on applications for all PJM websites using jQuery, ASP.NET, and C#</li>
                <li>Managed cross-browser compatibility across all sites (in order of highest priority: IE6 to IE9, Firefox, Chrome, Safari, Opera)</li>
                <li>Refined UI design for the PJM intranet portal homepage</li>
                <li>Utilized Web APIs such as Google Maps and WeatherUnderground to create widgets and tools</li>
              </ul>
              </div>

              <h2>Education</h2>
              
              <div className="entry">
              <span className="company">
                <a href="https://www.drexel.edu/" target="_blank" rel="noopener noreferrer">
                  <h3>Drexel University</h3>
                </a>
              </span>

              <span className="location">Philadelphia, PA</span>
              <span className="title">Bachelors of Science in Computer Science</span>
              <span className="year">September 2010 - June 2015</span>
              
              <ul>
                <li>Concentrations in Artificial Intelligence and Human-Computer Interaction</li>
                <li>Minor in Communications</li>
              </ul>
              </div>

            </div>
          </div>
        </section>
      </main>
    );
  }
}

export default Resume;

// Programming     : C#, C++, Java, Python <br>
// Web Development : HTML5, CSS3, Bootstrap, Sass, LESS, Jade/Pug, Swig, Handlebars, PHP, MEAN, LAMP <br>
// JavaScript : ES2016, jQuery, AJAX, Vue, React, Angular 1, Node.js, Webpack, Babel, Underscore, GruntJS, PhantomJS, Backbone <br>
// CMS        : KeystoneJS, WordPress, Drupal 8, Drupal 6, Sitecore <br>
// Database   : MongoDB, MySQL/MariaDB, Microsoft SQL Server <br>
// Cloud      : DigitalOcean, Heroku, OpenShift, Amazon Web Services <br>
// Tools      : Sublime Text, Sketch, Zeplin, Google Analytics/SEO, Postman, Acquia Dev Desktop, Visual Studio <br>
// Systems    : Mac OS X (10.6 through 10.11), Ubuntu 14.04/16.04, Windows 7/10</p>



// WEBPACK FOOTER //
// ./src/views/Resume.js